export default "__VITE_ASSET__Cp1TftMF__"